import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ComponentNameTranslationPipe,
  LevelNameTranslationPipe,
  StorageLevelToCustomerLevelNamePipe,
} from '@twaice-fe/frontend/shared/services';
import { Recommendation, StorageLevelV2, WeakCellPosition } from '@twaice-fe/shared/models';
import { NzCardComponent } from 'ng-zorro-antd/card';

@Component({
  selector: 'twaice-fe-weak-cell-recommendation',
  templateUrl: './weak-cell-recommendation.component.html',
  imports: [
    CommonModule,
    NzCardComponent,
    ComponentNameTranslationPipe,
    LevelNameTranslationPipe,
    StorageLevelToCustomerLevelNamePipe,
  ],
  providers: [LevelNameTranslationPipe],
  styleUrl: './weak-cell-recommendation.component.scss',
})
export class WeakCellRecommendationComponent {
  @Input() componentBk: string | undefined;
  @Input() enclosureBk: string | null;
  @Input() weakCellPosition: WeakCellPosition | null;
  @Input() hasSiblingEffect = false;

  @Input() quickFixBufferPercent: number;
  @Input() recommendation: Recommendation | null;

  protected readonly storageLevelV2 = StorageLevelV2;
  protected readonly Recommendation = Recommendation; // eslint-disable-line @typescript-eslint/naming-convention

  constructor(private levelIdentifierToLevelName: LevelNameTranslationPipe) {}

  getCellPosition(): string | null {
    const { cellPosition, modulePosition } = this.weakCellPosition ?? {};
    const cellPositionString = cellPosition
      ? `${this.levelIdentifierToLevelName.transform(StorageLevelV2.Cell)} ${cellPosition}`
      : null;
    const modulePositionString = modulePosition
      ? `${this.levelIdentifierToLevelName.transform(StorageLevelV2.StringModule)} ${modulePosition}`
      : null;

    if (cellPosition && modulePosition) {
      return `(${modulePositionString}, ${cellPositionString})`;
    }

    if (modulePosition) {
      return `(${modulePositionString})`;
    }

    if (cellPosition) {
      return `(${cellPositionString})`;
    }

    return null;
  }
}
